<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true #nav>
    <app-nav-tab [title]="t('organiser.event.details.tab.basic.data')" [itemId]="1" [isChecked]="!isEventInvalid"
                 [showIndicator]="true">
      <ng-template>
        <app-event-basic-data [currentEventItem]="currentEventItem" [eventDetailsComponentType]="componentType"
                              [currencies]="currencies" [countries]="countries" [eventTypes]="eventTypes"
                              [languages]="languages" [measurers]="measurers"
                              [organisers]="organisers" [userRole]="userRole" [sports]="sports"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.details.tab.event.info')" [itemId]="2"
                 [isChecked]="(!!currentEventItem?.rules || !!currentEventItem?.description)" [showIndicator]="true">
      <ng-template>
        @if (disableEditing()) {

          <ng-template [ngTemplateOutlet]="copyWarning"/>

        }
        <app-event-info [currentEventItem]="currentEventItem" [disableEditing]="disableEditing()"
                        [countries]="countries"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.details.tab.payment.settings')" [itemId]="3"
                 [isChecked]="!!currentPaymentSettings?.eventId" [showIndicator]="true">
      <ng-template>
        @if (disableEditing()) {
          <ng-template [ngTemplateOutlet]="copyWarning"/>
        }
        <app-event-payment-settings [currentPaymentSettings]="currentPaymentSettings"
                                    [disableEditing]="disableEditing() || changeDisabled(currentEventItem)"
                                    [paymentMethods]="paymentMethods"
                                    [event]="currentEventItem"
                                    [paymentTypes]="paymentTypes" [paymentReminderMethods]="paymentReminderMethods"
                                    (paymentSettingsSaved)="onChangeEventPaymentSettings($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.details.tab.receipts.invoices')" [itemId]="4" [isChecked]="false"
                 [showIndicator]="true">
      <ng-template>
        @if (disableEditing()) {
          <ng-template [ngTemplateOutlet]="copyWarning"/>
        }
        <ng-template [ngTemplateOutlet]="receiptsInvoices"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('app.common.races')" [itemId]="5"
                 [isChecked]="(currentEventItem?.racesList?.length ?? 0) > 0" [showIndicator]="true">
      <ng-template>
        @if (disableEditing()) {
          <ng-template [ngTemplateOutlet]="copyWarning"/>
        }
        <ng-template [ngTemplateOutlet]="races"/>
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>

  <ng-template #receiptsInvoices>
    <app-admin-card-with-title [cardTitle]="t('organiser.event.details.tab.receipts.invoices')"
                               [removeTopMargin]="true">
    </app-admin-card-with-title>
    <app-action-buttons-row [saveVisible]="false"/>
  </ng-template>

  <ng-template #races>
    <div class="admin-card">
      <app-admin-actions-header (onExportToPdf)="downloadListOfRaces('pdf')"
                                (onExportToXls)="downloadListOfRaces('xlsx')">
        <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
          <!--<div class="input-group flex-grow-0 search-max-width">
            <input type="text" class="form-control btn-min-height" [placeholder]="t('explore.search')"
              (input)="handleSearchInput($event)">
            &lt;!&ndash;          TODO (searchQuery)="handleSearchInput($event)"&ndash;&gt;
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>-->
          <app-rounded-button [label]="t('organiser.events.add.new.race')" (onClick)="goToAddRace()"
                              [isDisabled]="disableEditing()" [btnClass]="'rounded-button--solid'"><i
            class="bi bi-plus-circle pe-2"></i>
          </app-rounded-button>
        </div>
      </app-admin-actions-header>
      @if (currentEventItem?.racesList?.length ?? 0 > 0) {
        <div class="d-flex">
          <div class="flex-grow-1" style="overflow-x: hidden ">
            <div class="table-responsive d-xl-block d-none">
              <app-sortable-table cssClass="table dark-header table-last-row-no-border"
                                  [items]="currentEventItem?.racesList">
                <thead>
                <tr>
                  <th scope="col" [sortBy]="['id']" class="id-column-width">
                    {{ t('event.item.id') }}
                  </th>
                  <th scope="col" [sortBy]="['firstname','lastname']">
                    {{ t('app.common.item.name') }}
                  </th>
                  <th scope="col" [sortBy]="['raceStart']" data-type="date" class="date-column-width">
                    {{ t('event.item.date') }}
                  </th>
                  <th scope="col" [sortBy]="['competitorCount?.total']" class="competitor-column-width">
                    {{ t('event.item.competitor.count') }}
                  </th>
                  <th scope="col" [sortBy]="['status']" class="status-column-width">
                    {{ t('event.item.status') }}
                  </th>
                </tr>
                </thead>
                <tr app-table-header-separator></tr>
                <tbody>
                  @for (race of currentEventItem?.racesList;track race) {
                    <tr>
                      <td class="center-align">{{ race.id }}</td>
                      <td class="center-align">
                          <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [itLabel]="race.nameIta"
                                               [siLabel]="race.nameSlo" [srLabel]="race.nameSr" [bsLabel]="race.nameBs"
                                               [defaultLanguage]="currentEventItem?.defaultLanguage"
                                               [languages]="languages"/>
                      </td>
                      <td class="center-align text-nowrap">{{ race.raceStart ?? '' | localizedDate:'short' }}
                      </td>
                      <td
                        class="center-align">{{ race.competitorCount?.withStartNumber + '/' + race.competitorCount?.total }}</td>
                      <td class="center-align">
                        <div class="status-badge" [ngClass]="{'accepted': race.status === 1 , 'publishing': race.status === 2, 'denied': race.status
                         === 0 || race.status===4 || race.status===8 ,'on-hold': race.status === 5, 'blue':
                         race.status === 3}">
                  <span class="fw-bold">
                    {{ t("race.status." + race.status) | uppercase }}
                  </span>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </app-sortable-table>
            </div>
          </div>
          <div class="d-xl-block d-none">
            <table class="table dark-header table-last-row-no-border" style="table-layout: auto !important;">
              <thead>
              <tr>
                <th class="more-th">
                  {{ t("app.common.edit") }}
                </th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (race of currentEventItem?.racesList;track race) {
                  <tr>
                    <td class="more-td text-end center-align">
                      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="raceActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                        <ul aria-labelledby="raceActionsDropdown" ngbDropdownMenu>
                          <li (click)="goToRaceDetails(race)" ngbDropdownItem>{{ t("app.common.details") }}</li>
                          @if (!disableEditing() && !(race?.raceStartItems | filterByField:'started':null:true)?.length) {
                            <li ngbDropdownItem (click)="openEraseRaceConfirmationDialog(race)">
                              {{ t("app.common.delete") }}
                            </li>
                          }
                          @if (!disableEditing()) {
                            <li (click)="goToCopyRace(race)" ngbDropdownItem>{{ t("app.common.copy") }}
                            </li>
                          }
                        </ul>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

      } @else {
        <app-empty-state-admin/>
      }
      <!--      Mobile table-->
      @for (race of currentEventItem?.racesList;let isLast=$last;track race) {
        <div class="d-block d-xl-none" (click)="goToRaceManagement(race)">
          <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
            <div class="flex-grow-1">
              <div class="d-flex flex-column" [class.isLastRow]="isLast">
                <div>
                  {{ t('event.item.id') }}: {{ race.id }}
                </div>
                <div>
                  {{ t('app.common.item.name') }}:
                  <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng"  [srLabel]="race.nameSr"  [bsLabel]="race.nameBs" [itLabel]="race.nameIta"
                                       [siLabel]="race.nameSlo" [defaultLanguage]="currentEventItem?.defaultLanguage"
                                       [languages]="languages"/>
                </div>
                <div>
                  {{ t('event.item.date') }}
                  : {{ race.raceStart ?? ''| localizedDate:'short' }}
                </div>

                <div>
                  {{ t('event.item.competitor.count') }}: {{ race.competitorCount?.withStartNumber + '/' + race.competitorCount?.total }}
                </div>
                <div>
                  Status: {{ t("race.status." + race.status) }}
                </div>
              </div>
            </div>
            <div (click)="handleDropdownClick($event)">
              <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
              <span class="menu-icon" id="raceActionsDropdownMobile" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </span>
                <ul aria-labelledby="raceActionsDropdown" ngbDropdownMenu>
                  <li (click)="goToRaceDetails(race)" ngbDropdownItem>{{ t("app.common.details") }}</li>
                  @if (!disableEditing()) {
                    <li ngbDropdownItem (click)="openEraseRaceConfirmationDialog(race)">
                      {{ t("app.common.delete") }}
                    </li>
                  }
                  @if (!disableEditing()) {
                    <li ngbDropdownItem>{{ t("app.common.copy") }}</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      }

    </div>
    <app-action-buttons-row [saveVisible]="false"/>
  </ng-template>

  <ng-template #copyWarning>
    <p>
      <ngb-alert [dismissible]="false" class="warning-info mb-4">
        {{ t("event.details.copy.message.1") }} <strong><a (click)="navigateToEventBasicInfo()">
        {{ t("event.details.copy.message.2") }}</a></strong>
      </ngb-alert>
    </p>
  </ng-template>

</ng-container>
